// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3d4b00a5","118":"09d455ee","330":"9e84b9d3","361":"a5af3e5f","377":"5682b9d8","453":"3cb1ae6e","462":"37feaed1","569":"ace3ae68","669":"6c57af80","784":"a220a4a0","900":"95fcf3e2","939":"130dc8b8"}[chunkId] + ".chunk.js";
};